<div *ngIf="dataLoading">
  <h3 style="text-align:center;">LOADING ORDERS</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="container" style="width:100%" [formGroup]="orderForm" *ngIf="!dataLoading">
	<mat-table #table [dataSource]="dataSource" matSort matSortActive="vendor" matSortDirection="asc" class="mat-elevation-z2" formArrayName="orders" multiTemplateDataRows>
	  <ng-container matColumnDef="alert">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 40px"> </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 40px" class="stack-alert-cell">
	      <mat-icon
	        color="warn"
	        *ngIf="needsFollowUpAlert(order)"
	        [matTooltip]="holdOverdueReason(order)"
	      >notification_important</mat-icon>
	    </mat-cell>
	  </ng-container>

		<ng-container matColumnDef="images">
      <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 0 185px"> IMAGE </mat-header-cell>
      <mat-cell *matCellDef="let order; let i=dataIndex; " fxFlex="1 0 185px" [formGroupName]="i">
      	<app-image
					type="product"
					[edit]="false" 
					[delete]="false" 
					[upload]="false" 
					[active]="orderId==order.value._id"
					[productId]="order.value.products[0].product._id">
				</app-image>
      </mat-cell>
    	<mat-footer-cell *matFooterCellDef fxFlex="1 0 85px"> </mat-footer-cell>
    </ng-container>

	  <ng-container matColumnDef="model">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 14%"> MODEL </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let j=index; let k=renderIndex; let row;" fxFlex="1 1 14%" [formGroupName]="i" class="stack-wrap-cell">
	    	<span *ngIf="orderId!=order.value._id">{{order.value.products[0].product.model}}</span>
	    	<app-autocomplete-vendor-products 
	  			[(productForm)]="order.controls.products['controls'][0]['controls']['product']" 
	    		[vendor]="order.value.products[0].product.vendor" 
	  			placeholder="MODEL"
	  			*ngIf="orderId==order.value._id" 
	  			(selected)="updateProduct($event,order,i)" 
	  			[(fieldOpen)]="fieldOpen" 
	  			displayField="model" 
					fxFlex="1 1 90%"
	  			>
				</app-autocomplete-vendor-products>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="color">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 14%"> COLOR </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 14%" [formGroupName]="i" class="stack-wrap-cell">
	    	<span *ngIf="orderId!=order.value._id">{{order.value.products[0].product.color}}</span>
	    	<app-autocomplete-vendor-products 
	  			[(productForm)]="order.controls.products['controls'][0]['controls']['product']" 
	    		[vendor]="order.value.products[0].product.vendor" 
	  			placeholder="COLOR"
	  			*ngIf="orderId==order.value._id" 
	  			(selected)="updateProduct($event,order,i)" 
	  			[(fieldOpen)]="fieldOpen" 
	  			displayField="color" 
					fxFlex="1 1 90%"
	  			>
				</app-autocomplete-vendor-products>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="size">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 1 70px"> SIZE </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 1 70px" [formGroupName]="i" class="stack-wrap-cell">
	    	<span *ngIf="orderId!=order.value._id"> {{order.value.products[0].product.size}} </span>
	    	<app-autocomplete-vendor-products 
	  			[(productForm)]="order.controls.products['controls'][0]['controls']['product']" 
	    		[vendor]="order.value.products[0].product.vendor" 
	  			placeholder="SIZE"
	  			*ngIf="orderId==order.value._id" 
	  			(selected)="updateProduct($event,order,i)" 
	  			[(fieldOpen)]="fieldOpen" 
	  			displayField="size" 
	  			>
				</app-autocomplete-vendor-products>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="type">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 60px"> TYPE </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 60px" [formGroupName]="i">
	    	<span *ngIf="orderId!=order.value._id && order.value._id!=''">{{order.value.products[0].type}}</span>
	    	<ng-container formGroupName="products">
		    	<ng-container [formGroupName]="0">
						<mat-form-field *ngIf="orderId==order.value._id || order.value._id==''" floatLabel="never" style="width:90%">
							<mat-select #formRow placeholder="TYPE" formControlName="type" (click)="clickField();$event.stopPropagation();" (selectionChange)="changeProductType($event,order)">
								<mat-option *ngFor="let typeOption of productTypeOptions" [value]="typeOption.value">
									{{typeOption.viewValue}}
								</mat-option>
							</mat-select>
		        </mat-form-field>
	        </ng-container>
		    </ng-container>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="status">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 40px"> </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 40px" [ngClass]="order.value.products[0].product.status">
	      <span>&nbsp;</span>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="patientStock">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 100px"> ORDER FOR </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 100px" [formGroupName]="i">
	    	<span>{{order.value.products[0].frame.frameSource}}</span>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="patient">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 16%"> PATIENT </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 16%" [formGroupName]="i" class="stack-wrap-cell">
	      <button mat-button *ngIf="order.value.patient" [routerLink]="['/admin/patient', order.value.patient._id]" (click)="clickButton($event,order,i)" class="stack-patient-button">{{order.value.patient.lastName}}, {{order.value.patient.firstName}}</button>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="invoiceNumber">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 110px"> INVOICE # </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 110px" [formGroupName]="i">
	    	<span *ngIf="orderId!=order.value._id && order.value.invoiceNumber" [class.priority-redo-invoice]="order.value.redoPriority">{{order.value.type}}&nbsp;&ndash;&nbsp;{{order.value.invoiceNumber }}<span class="fulfillment-ship-badge" *ngIf="order.value.fulfillment === 'SHIP' && order.value.status !== 'DISPENSED'">SHIP</span></span>
	    	<mat-form-field *ngIf="orderId==order.value._id" floatLabel="never">
				  <mat-select placeholder="TYPE" formControlName="type" style="width:30px;" (click)="clickField()" (selectionChange)="clickField()">
						<mat-option *ngFor="let orderTypeOption of orderTypeOptions" [value]="orderTypeOption.value">
							{{ orderTypeOption.viewValue }}
						</mat-option>
					</mat-select>
				</mat-form-field>
	    	<mat-form-field *ngIf="orderId==order.value._id" floatLabel="never">
		      <input matInput placeholder="INVOICE #" formControlName="invoiceNumber" (click)="clickField()">
		    </mat-form-field>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="todo">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 100px"> TO-DO </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 100px" [formGroupName]="i">
	    	<span>{{ stackTodoLabel(order) }}</span>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="eta">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 0 120px"> {{ tableView === 'hold' ? 'FOLLOW-UP' : 'ETA' }} </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 120px" [formGroupName]="i">
				<span *ngIf="orderId!=order.value._id"> {{ stackEtaValue(order) | date:'M/d/yy' }} </span>
	      <mat-form-field *ngIf="orderId==order.value._id" floatLabel="never">
				  <input #formRow [matDatepicker]="picker" matInput placeholder="ETA" type="text" formControlName="eta" (dateChange)="clickDate($event,order,i)">
				  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
	      	<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="view">
	    <mat-header-cell *matHeaderCellDef fxFlex="0 0 40px"></mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex;" fxFlex="0 0 40px" class="stack-view-cell">
	      <button
	        mat-icon-button
	        type="button"
	        class="stack-view-order-button"
	        (click)="openOrderEdit($event, order)"
	        aria-label="View order"
	      >
	        <mat-icon>visibility</mat-icon>
	      </button>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="log">
	    <mat-header-cell *matHeaderCellDef fxFlex="0 0 48px"></mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 0 48px" class="stack-icon-cell">
	    	<app-log-menu [order]="order" [small]="true" [alwaysShow]="true" (clickField)="clickField()"></app-log-menu>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="frame">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 18%"> FRAME </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 18%" class="stack-wrap-cell">
	      {{ frameLabel(order) }}
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="vendorName">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 14%"> VENDOR </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 14%" class="stack-wrap-cell">
	      {{ vendorName(order) }}
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="orderDate">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 1 110px"> ORDER DATE </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 1 110px">
	      <span *ngIf="orderDateValue(order)">{{ orderDateValue(order) | date:'M/d/yy' }}</span>
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="referenceNumber">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="1 1 12%"> REFERENCE # </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="1 1 12%" class="stack-wrap-cell">
	      {{ referenceNumber(order) }}
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="payment">
	    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="0 1 130px"> PAYMENT </mat-header-cell>
	    <mat-cell *matCellDef="let order; let i=dataIndex; let row;" fxFlex="0 1 130px" class="stack-wrap-cell">
	      {{ paymentLabel(order) }}
	    </mat-cell>
	  </ng-container>

	  <ng-container matColumnDef="expandedDetail">
	 	  <mat-cell *matCellDef="let order2; let orderIndex=dataIndex;" [formGroupName]="orderIndex" class="expandedCell">
	      <div class="example-element-detail" style="width:100%" [class.mat-elevation-z0]="order2!=expandedElement" [class.mat-elevation-z8]="order2==expandedElement" [@detailExpand]="order2 == expandedElement ? 'expanded' : 'collapsed'">
	      		<mat-table #table [dataSource]="dataSource2[orderIndex]" class="mat-elevation-z2">
						  

						  <ng-container matColumnDef="notes">
						    <mat-header-cell *matHeaderCellDef fxFlex="1 1 50%"> NOTES </mat-header-cell>
						    <mat-cell *matCellDef="let order; let i=index; let row;" fxFlex="1 1 50%">
						      <span *ngIf="orderId!=order.value._id">{{ order.value.notes }}</span>
						      <mat-form-field *ngIf="orderId==order.value._id" style="width:100%;padding-left:10px;padding-right:10px;" floatLabel="never">
							      <input matInput placeholder="NOTES" formControlName="notes" (click)="clickField()">
							    </mat-form-field>
						    </mat-cell>
						  </ng-container>

						  <ng-container matColumnDef="cost">
						    <mat-header-cell *matHeaderCellDef fxFlex="0 0 60px"> COST </mat-header-cell>
						    <mat-cell *matCellDef="let order; let i=index; let row;" fxFlex="0 0 60px">
						      <span *ngIf="orderId!=order.value._id || (!authorized && order.value.products[0].product._id)">{{order.value.products[0].cost | currency : 'USD' : 'symbol' : '1.0' }}</span>
						    	<ng-container formGroupName="products">
							    	<ng-container [formGroupName]="0">
								      <mat-form-field *ngIf="orderId==order.value._id && (authorized || !order.value.products[0].product._id)" floatLabel="never">
								        <input #formRow matInput placeholder="COST" type="text" formControlName="cost" (keyup)="changeCost(order)">
								      </mat-form-field>
								    </ng-container>
							    </ng-container>
						    </mat-cell>
						  </ng-container>

						  <ng-container matColumnDef="retail">
						    <mat-header-cell *matHeaderCellDef fxFlex="0 0 60px"> RETAIL </mat-header-cell>
						    <mat-cell *matCellDef="let order; let i=index; let row;" fxFlex="0 0 60px">
						    	<span *ngIf="orderId!=order.value._id || (!authorized && order.value.products[0].product._id)">{{order.value.products[0].retail | currency : 'USD' : 'symbol' : '1.0' }}</span>
						    	<ng-container formGroupName="products">
							    	<ng-container [formGroupName]="0">
								    	<mat-form-field *ngIf="orderId==order.value._id && (authorized || !order.value.products[0].product._id)" floatLabel="never">
								        <input #formRow matInput placeholder="RETAIL" type="text" formControlName="retail" (keyup)="changeRetail(order)">
								      </mat-form-field>
								    </ng-container>
								  </ng-container>
						    </mat-cell>
						  </ng-container>

						  <ng-container matColumnDef="priceLink">
						    <mat-header-cell *matHeaderCellDef fxFlex="0 0 35px">  </mat-header-cell>
						    <mat-cell *matCellDef="let order; let i=index;" fxFlex="0 0 35px">
						      <mat-icon (click)="togglePriceLink($event,order)" *ngIf="order.value.products[0].pricingFormula!='c'">link_outline</mat-icon>
						      <mat-icon (click)="togglePriceLink($event,order)" *ngIf="order.value.products[0].pricingFormula=='c'" color="warn">link_off_outline</mat-icon>
						    </mat-cell>
						  </ng-container>

				  	  <ng-container matColumnDef="duty">
						    <mat-header-cell *matHeaderCellDef fxFlex="0 0 40px"> DUTY </mat-header-cell>
						    <mat-cell *matCellDef="let order; let i=index" class="duty" fxFlex="0 0 40px">
						    	<ng-container formGroupName="products">
							    	<ng-container [formGroupName]="0">
							    		<mat-checkbox formControlName="duty" *ngIf="orderId==order.value._id" (click)="clickField()"></mat-checkbox>
							    	</ng-container>
						    	</ng-container>
						    </mat-cell>
						  </ng-container>

						  <ng-container matColumnDef="retailPlusDuty">
						    <mat-header-cell *matHeaderCellDef fxFlex="0 0 60px"> RETAIL + DUTY </mat-header-cell>
						    <mat-cell *matCellDef="let order; let i=index" class="duty" fxFlex="0 0 60px">
			    				{{ settingsService.getRetailPlusDuty(order.value.products[0].retail) | currency : 'USD' : 'symbol' : '1.0' }}
						    </mat-cell>
						  </ng-container>

				  	  <ng-container matColumnDef="action">
						    <mat-header-cell *matHeaderCellDef fxFlex="0 0 150px"></mat-header-cell>
						    <mat-cell *matCellDef="let order; let i=index; let j = dataIndex" fxFlex="0 0 150px">
						    	<mat-form-field style="width:35px;flex: 0 1 35px;padding-left:10px;" floatLabel="never">
							      <input matInput required placeholder="" type="text" formControlName="initials" (click)="$event.stopPropagation()">
							      <mat-label><mat-icon>gesture</mat-icon></mat-label>
							    </mat-form-field>
						      <button mat-button [matMenuTriggerFor]="menu" (menuClosed)="clickField()"><mat-icon>more_vert</mat-icon><span>SAVE</span></button>
						      <mat-menu #menu="matMenu">
						    	 	<button mat-menu-item type="button" (click)="saveFrame(order)" style="margin-left:10px;" [disabled]="order.controls.initials.invalid">SAVE CHANGES</button>
						        <button mat-menu-item type="button" (click)="orderFrame(order,orderIndex)" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || (order.controls.invoiceNumber.invalid && order.value.products[0].frame.frameSource == 'PATIENT')" *ngIf="order.value.type!='F'">ORDERED FRAME</button>
						        <button mat-menu-item type="button" (click)="orderFrame(order,orderIndex)" style="margin-left:10px;" [disabled]="order.controls.initials.invalid || (order.controls.invoiceNumber.invalid && order.value.products[0].frame.frameSource == 'PATIENT')" *ngIf="order.value.type=='F'">SENT OUT...</button>
						        <button mat-menu-item type="button" (click)="onCancelFrame(order)" style="margin-left:10px;" [disabled]="order.controls.initials.invalid">CANCEL ORDER</button>
						      </mat-menu>
						    </mat-cell>
						  </ng-container>

						  <mat-header-row 
						  	*matHeaderRowDef="getDisplayedColumns2(order2)" 
						  	fxLayout="row" 
						  	fxLayoutAlign="start center">
						  </mat-header-row>
						  <mat-row 
						  	*matRowDef="let row; columns: getDisplayedColumns2(order2); let i=index; let even=even; let odd=odd;" 
						  	fxLayout="row" 
						  	fxLayoutAlign="start stretch"
						  	style="border-left:1px solid #dfdfdf !important;"
						  	(click)="clickOrder($event, row, orderIndex)">
						  </mat-row>
						</mat-table>

				</div>
	    </mat-cell>
	  </ng-container>

	  <mat-header-row 
	  	*matHeaderRowDef="displayedColumns" 
	  	fxLayout="row" 
	  	fxLayoutAlign="start center">
	  </mat-header-row>

	  <mat-row 
	  	*matRowDef="let row; columns: displayedColumns; let i=dataIndex; let even=even; let odd=odd;" 
	  	fxLayout="row" 
	  	fxLayoutAlign="start center" 
	  	[ngClass]="{rowEven:i%2, rowOdd:(i+1)%2, 'stack-hold-overdue': needsFollowUpAlert(row)}" 
	  	style="border-left:1px solid #dfdfdf !important;" 
	  	(click)="toggleExpanded($event, row, i)">
	  </mat-row>
	  <mat-row *matRowDef="let element; columns: ['expandedDetail']" 
	  	[class.example-detail-row-expanded]="expandedElement === element"
	  	[class.example-detail-row-collapsed]="expandedElement !== element"
      style="overflow: hidden"
      fxLayoutAlign="start center">
    </mat-row>
	</mat-table>
</div>

